// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * What CoreButtonView's TCoreButtonStyleProps cannot express:
 *   1. Responsive max-width breakpoints — single \`maxWidth\` string can't do MQs.
 *   2. Absolute positioning for the notification badge — TCoreLayoutStyleProps
 *      has no \`position\`/\`top\`/\`right\`. The badge itself is rendered as a
 *      CoreLayoutView (pink circle); this class only places it in the corner.
 *
 * The badge cannot live INSIDE CoreButtonView because \`.btn\` has
 * \`overflow: hidden\` (button.module.css), which would clip any child positioned
 * at \`top:-2px; right:-2px\`.
 */
.buttonBanner-module_buttonBannerWrapper__j1qOe {
    position: relative;
    flex: 1;
    display: flex;
    /*
     * Column direction with default \`align-items: stretch\` reliably stretches the
     * single child <button> to the wrapper's full cross-axis (horizontal) width,
     * regardless of the wrapper's flex context (column-stretch parent, row-flex parent, etc.).
     * Without this, \`width: 100%\` on the inner <button> was resolving to less than wrapper
     * width in some parent layouts, leaving the absolutely-positioned badge floating
     * beyond the button's right edge.
     */
    flex-direction: column;

    @media screen and (min-width: 708px) {
        max-width: 432px;
    }

    @media screen and (min-width: 889px) {
        max-width: 552px;
    }
}

.buttonBanner-module_buttonBannerBadge__utZ42 {
    position: absolute;
    top: -2px;
    right: -2px;
    pointer-events: none;
    z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Buttons/styles/buttonBanner.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;AACF;IACI,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb;;;;;;;MAOE;IACF,sBAAsB;;IAEtB;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB,UAAU;AACd","sourcesContent":["/*\n * What CoreButtonView's TCoreButtonStyleProps cannot express:\n *   1. Responsive max-width breakpoints — single `maxWidth` string can't do MQs.\n *   2. Absolute positioning for the notification badge — TCoreLayoutStyleProps\n *      has no `position`/`top`/`right`. The badge itself is rendered as a\n *      CoreLayoutView (pink circle); this class only places it in the corner.\n *\n * The badge cannot live INSIDE CoreButtonView because `.btn` has\n * `overflow: hidden` (button.module.css), which would clip any child positioned\n * at `top:-2px; right:-2px`.\n */\n.buttonBannerWrapper {\n    position: relative;\n    flex: 1;\n    display: flex;\n    /*\n     * Column direction with default `align-items: stretch` reliably stretches the\n     * single child <button> to the wrapper's full cross-axis (horizontal) width,\n     * regardless of the wrapper's flex context (column-stretch parent, row-flex parent, etc.).\n     * Without this, `width: 100%` on the inner <button> was resolving to less than wrapper\n     * width in some parent layouts, leaving the absolutely-positioned badge floating\n     * beyond the button's right edge.\n     */\n    flex-direction: column;\n\n    @media screen and (min-width: 708px) {\n        max-width: 432px;\n    }\n\n    @media screen and (min-width: 889px) {\n        max-width: 552px;\n    }\n}\n\n.buttonBannerBadge {\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    pointer-events: none;\n    z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonBannerWrapper": `buttonBanner-module_buttonBannerWrapper__j1qOe`,
	"buttonBannerBadge": `buttonBanner-module_buttonBannerBadge__utZ42`
};
export default ___CSS_LOADER_EXPORT___;
